"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.errorHandler = exports.asError = void 0;

require("rxjs/add/observable/of");

var _rxjs = require("rxjs");

var _Observable = require("rxjs/Observable");

/**
 * Ensures that an error is of type Error rather than any type such reason paramter of a catch statement.
 * Example usage is flux standard actions which by convention has errors of type Error for the payload of the action.
 * @param error If the value is an object then it will converted to string via toString
 */
var asError = function asError(error) {
  return error instanceof Error ? error : new Error(error);
};

exports.asError = asError;

var errorHandler = function errorHandler(type, parent, options) {
  var errorMessages = options && options.errorMessages;
  return function (error) {
    var err = asError(error);

    if (errorMessages && err instanceof _rxjs.AjaxError) {
      var errorMessage = errorMessages.get(err.status);
      err.localizedMessage = errorMessage;
    }

    return _Observable.Observable.of({
      type: type,
      payload: err,
      meta: {
        parent: parent
      },
      error: true
    });
  };
};

exports.errorHandler = errorHandler;